<template>
    <div class="popup-wrap">
        <div
            class="popup-modal"
            :class="{ '-dark': dark }"
            @click="close"
        ></div>
        <div
            class="popup-content"
            :class="{ '-wide': wide, '-dark': dark, '-narrow': narrow }"
        >
            <div class="popup-content-header" v-if="header">
                <div class="popup-header-title">{{ $t(title) }}</div>
                <i v-if="!blockClose" class="material-icons" @click="close"
                    >close</i
                >
            </div>
            <div class="popup-slot" ref="content">
                <slot></slot>
            </div>
            <div class="popup-actions" v-if="actions && actions.length > 0">
                <ActionButton
                    style="margin-left: 0.5rem"
                    :button_id="action.action.name || action.action"
                    :color="action.color"
                    @click="emitAction(action)"
                    :label="$t(action.display)"
                    :materialIcon="action.materialIcon"
                    :loading="action.loading"
                    v-for="(action, index) in filteredActions"
                    :key="index"
                />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        header: {
            type: Boolean,
            default: true
        },
        title: String,
        actions: Array,
        wide: Boolean,
        narrow: Boolean,
        blockClose: Boolean,
        dark: Boolean
    },
    computed: {
        filteredActions() {
            return this.actions.filter(a => !a.hidden)
        }
    },
    methods: {
        addScroll(scroll) {
            this.$nextTick(() => {
                this.$refs.content.scrollTop += scroll
            })
        },
        scrollTop() {
            this.$nextTick(() => {
                this.$refs.content.scrollTop = this.$refs.content.scrollHeight
            })
        },
        emitAction(payload) {
            if (payload.action.name) {
                this.$emit('action', payload.action)
            } else {
                this.$emit(payload.action)
            }
        },
        close() {
            if (this.blockClose) {
                return
            }
            this.$emit('close')
        },
        keyboardEvent(event) {
            switch (event.keyCode) {
                case 27:
                    this.close()
                    break
                case 13:
                    if (!event.shiftKey) {
                        this.$emit('submit')
                    }
            }
        }
    },
    mounted() {
        window.addEventListener('keyup', this.keyboardEvent)
    },
    beforeDestroy() {
        window.removeEventListener('keyup', this.keyboardEvent)
    }
}
</script>
<style lang="scss" scoped>
.popup-content {
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow-y: visible;

    &.-dark {
        box-shadow: none;
        background: #303030;
        color: #fff !important;
        i {
            color: #fff;
        }
    }
    &.-wide {
        width: 80%;
    }
    &.-narrow {
        width: 30%;
    }
}
.popup-modal {
    &.-dark {
        background: #535353bb;
    }
}
.popup-content-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border-bottom: $list-border;
    font-size: 1.5rem;
    font-family: $input-family;

    i {
        margin-left: auto;
        transition: $ease;
        cursor: pointer;
        color: $input;

        &:hover {
            transform: translateY(0.1rem);
        }
    }
}
.popup-slot {
    max-height: 100%;
    overflow-y: auto;
    padding: 1rem;
    scroll-behavior: smooth;
}
.popup-actions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 1rem;
    border-top: $list-border;
}
</style>
